<template>
	<app-table
		class="is-not-selectable no-main-list mt-2"
		:columns="columns"
		:main-list="false"
		name="ledger-detail"
		padding="px-0"
		:rows="rows"
		:filter-columns="false"
		@on-search-event="$emit('on-search', $event)"
		@row-on-click="$emit('row-on-click', $event)"
	>
		<template slot="rows" slot-scope="props">
			<td	class="is-not-selectable"
				v-show="showRow(columns, 1)">
				<input @keyup.up="$emit('up-selected', props.row)"
					@keyup.down="$emit('down-selected', props.row)">
				{{ props.row.code ||props.row.accountingSeatId }}
			</td>
			<td v-show="showRow(columns, 2)">{{ props.row.account }}</td>
			<td v-show="showRow(columns, 3)">{{ props.row.reference }}</td>
			<td v-show="showRow(columns, 4)">{{ props.row.concept }}</td>
			<td class="text-xs-right pr-1" v-show="showRow(columns, 5)">{{ (props.row.amount || 0) | formatAmount}}</td>
		</template>
	</app-table>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function data() {
	return {
		columns: [
			{
				id: 1,
				name: 'Código',
				value: 'code',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 2,
				name: 'Cuenta Contable',
				value: 'account',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 3,
				name: 'Referencia',
				value: 'reference',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 4,
				name: 'Concepto',
				value: 'concept',
				checked: true,
				visible: true,
				movil: true,
			},
			{
				id: 5,
				name: 'Importe',
				value: 'amount',
				checked: true,
				visible: true,
				movil: true,
			},
		],
	};
}

export default {
	name: 'ledger-detail-list',
	components: {
		appTooltipButton,
	},
	data,
	props: {
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ledger/ledger-detail-list.vue